"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iconFactory_1 = require("../../utils/iconFactory");
// AEM-Name: BookmarkIcon
exports.BookmarkIcon = iconFactory_1.iconFactory({
    componentName: 'BookmarkIcon',
    viewBox: '0 0 32 32',
    title: 'BookmarkIcon',
    g: "<g>\n<path d=\"M23.968 27.52c-0.192 0-0.384-0.064-0.544-0.16l-7.36-5.216-7.488 5.216c-0.288 0.192-0.64 0.224-0.96 0.064s-0.48-0.48-0.48-0.832v-21.184c0-0.512 0.416-0.928 0.928-0.928h15.936c0.512 0 0.928 0.416 0.928 0.928v21.184c0 0.352-0.192 0.672-0.512 0.832-0.16 0.064-0.32 0.096-0.448 0.096z\"/>\n</g>",
    gThemed: { "ergo-one": { "viewBox": "0 0 32 32", "g": "<g><path d=\"M23.968 27.52c-0.192 0-0.384-0.064-0.544-0.16l-7.36-5.216-7.488 5.216c-0.288 0.192-0.64 0.224-0.96 0.064s-0.48-0.48-0.48-0.832v-21.184c0-0.512 0.416-0.928 0.928-0.928h15.936c0.512 0 0.928 0.416 0.928 0.928v21.184c0 0.352-0.192 0.672-0.512 0.832-0.16 0.064-0.32 0.096-0.448 0.096z\"/></g>" } }
});
exports.default = exports.BookmarkIcon;
//# sourceMappingURL=BookmarkIcon.js.map